module.exports = __webpack_public_path__ + "img/status.fb3f29f0.png";